import { isNullOrUndefined } from '@/utils/helpers';
import { STATIC_INBOXES_IDS } from '@/components/Inbox/inbox.const.js';

const hasPermissionToEditInbox = ({ inbox, userId }) => inbox.owner === userId;
const isInboxVirtual = (inboxId) => Object.values(STATIC_INBOXES_IDS).includes(inboxId);
const doesInboxIncludePersonalItems = (inboxId) => [STATIC_INBOXES_IDS.PRIVATE_INBOX_ID, STATIC_INBOXES_IDS.ALL_INBOX_ID].includes(inboxId);
const isAlertRelevantToInbox = ({ alert, inboxId }) => {
	if (inboxId === STATIC_INBOXES_IDS.ALL_INBOX_ID) {
		return true;
	} else if (inboxId === STATIC_INBOXES_IDS.PRIVATE_INBOX_ID) {
		return isNullOrUndefined(alert.inbox);
	} else if (inboxId === STATIC_INBOXES_IDS.SHARED_INBOX_ID) {
		return !isNullOrUndefined(alert.inbox);
	}
	return alert.inbox == inboxId;
};

const InboxService = {
	isInboxVirtual,
	isAlertRelevantToInbox,
	hasPermissionToEditInbox,
	doesInboxIncludePersonalItems,
};
export default InboxService;
